import { GetSpin } from "./action";

const loading = (state = { spinStatus: false }, action: any) => {
  switch (action.type) {
    case GetSpin:
      return Object.assign({}, { spinStatus: action.rs });
    default:
      return state;
  }
}

export default loading;